import { markUserNuxAsSeen } from '../services/UserService';
import { nuxKeyFor } from './adKeys';

/**
 * Retire one ad for this teacher, everywhere, for good.
 *
 * The write is optimistic — local state first, then a fire-and-forget POST. The
 * no-op error handler keeps a failed persist out of the global error modal:
 * markUserNuxAsSeen's default message is sign-in copy, nonsense for a dismissal.
 * The local hide already worked; the ad just comes back next session.
 */
export const persistAdDismissal = ({ diffitUser, setDiffitUser, adId }) => {
  if (!diffitUser) return;

  // A flat, top-level key merged into the rest: the server merges seen_nux at
  // the top level ONLY, so the sibling keys have to be carried across by hand.
  const seenNux = { ...diffitUser.seen_nux_json, [nuxKeyFor(adId)]: { dismissed: true } };

  setDiffitUser((prev) => ({ ...prev, seen_nux_json: seenNux }));
  markUserNuxAsSeen(diffitUser.id, seenNux, () => {}).catch(() => {});
};
